module.exports = __webpack_public_path__ + "static/media/rain.e0bb6c51.png";